import { render, staticRenderFns } from "./record.vue?vue&type=template&id=46cd13a0"
import script from "./record.vue?vue&type=script&lang=ts"
export * from "./record.vue?vue&type=script&lang=ts"
import style0 from "./record.vue?vue&type=style&index=0&id=46cd13a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports